import { useRouter } from 'next/router';
import { ComponentType, useEffect } from 'react';

import { PAGE_ROUTES } from 'lib/page-routes';
import { useAuth } from 'lib/providers/AuthProvider';

export function withAuth<T>(Component: ComponentType<T>): ComponentType<T> {
  return (hocProps: T) => {
    const router = useRouter();
    const {
      isAuthLoading,
      isManager,
      isRecruiter,
      recruiter,
      manager,
      isInitialAuthLoading,
    } = useAuth();

    useEffect(() => {
      if (isAuthLoading || isInitialAuthLoading) return;
      if (router) {
        const { type } = router.query;

        if (!isManager && !isRecruiter) {
          setTimeout(() => {
            if (type) {
              router.replace(
                type === 'recruiter'
                  ? PAGE_ROUTES.SIGN_IN_RECRUITER
                  : PAGE_ROUTES.SIGN_IN_SOCIETY
              );
            } else {
              router.replace(PAGE_ROUTES.CANDIDATE_SIGN_IN);
            }
          }, 500);
        }
      }
    }, [isAuthLoading, isManager, isRecruiter, router, recruiter, manager]);

    if (isManager || isRecruiter) {
      //@ts-ignore
      return <Component {...hocProps} />;
    } else {
      return null;
    }
  };
}
